/**
 * Los mensajes flotantes del módulo Calidad de código: lo que comparten el
 * servicio que los pide (flotantes-cc.service.ts) y el componente que los
 * pinta (flotante-cc.component.ts). Van sobre ngx-toastr, con sus opciones
 * en cada llamada: las globales del COS no se tocan.
 */

/** El tono del mensaje: cada uno con su icono y su color. */
export type TipoFlotanteCc = "exito" | "info" | "aviso" | "error";

/** Un enlace dentro del mensaje: su texto y la ruta del COS a la que lleva. */
export interface AccionFlotanteCc {
  texto: string;
  ruta: string;
}

/** Lo que viaja en el payload de ngx-toastr hasta el componente. */
export interface DatosFlotanteCc {
  tipo: TipoFlotanteCc;
  accion: AccionFlotanteCc | null;
  /** Un icono propio (Material Icons); sin él, el del tipo. */
  icono: string | null;
}

/** Cuánto se queda cada mensaje antes de irse solo: 15 segundos (pedido de Norman, 12/10/2026). */
export const DURACION_FLOTANTE_CC = 15_000;

/**
 * La clase del contenedor que crea ngx-toastr para el módulo: arriba a la derecha, bajo la barra del COS, como los
 * demás avisos del COS (flotante-cc.component.css).
 */
export const POSICION_FLOTANTES_CC = "cc-flotantes";

/** A lo más estos a la vez: con uno más, el más viejo se va. */
export const MAXIMO_FLOTANTES_CC = 4;

/** Lo que tarda la salida (ms); la entrada dura 200 ms. Los dos en el CSS del componente. */
export const SALIDA_FLOTANTE_CC = 180;

/** La raíz de las rutas del módulo: fuera de ella sus mensajes ya no dicen nada y se cierran. */
export const RAIZ_CALIDAD_CODIGO = "/admin/calidad-codigo";

/** El icono, el prefijo para lectores de pantalla y la urgencia de cada tipo. */
export const TIPOS_FLOTANTE_CC: Record<TipoFlotanteCc, { icono: string; prefijo: string; urgente: boolean }> = {
  exito: { icono: "check_circle", prefijo: "Listo:", urgente: false },
  info: { icono: "info", prefijo: "Información:", urgente: false },
  aviso: { icono: "warning_amber", prefijo: "Atención:", urgente: false },
  error: { icono: "error_outline", prefijo: "Error:", urgente: true },
};
